module.exports = __webpack_public_path__ + "e2f221fa7fe83a56dba03cde15d4995f.png";